import users from 'collections/usersInstance'
import fetchOncePromise from 'libraries/fetchOncePromise'

export default fetchOncePromise(users);
